/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HtmlResp } from '../../models/html-resp';

export interface ApiHomeGet$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiHomeGet(http: HttpClient, rootUrl: string, params?: ApiHomeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<HtmlResp>> {
  const rb = new RequestBuilder(rootUrl, apiHomeGet.PATH, 'get');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HtmlResp>;
    })
  );
}

apiHomeGet.PATH = '/api/Home';
